
import { InputBase, InputRruleController } from "../../controllers";

import { Objects } from "@salaxy/core";

import { ComponentBase } from "../_ComponentBase";

/**
 * Shows a an editor / display component for a Recurrence Rule (RRule).
 * Recurrence rules are a strings defined in iCalendar format, e.g. "FREQ=MONTHLY;INTERVAL=1".
 * For more information and examples, see http://jakubroztocil.github.io/rrule/ or https://icalendar.org/iCalendar-RFC-5545/3-8-5-3-recurrence-rule.html
 * @example
 * ```html
 * <salaxy-input-rrule name="myInput" ng-model="temp" label="Basic example"></salaxy-input-rrule>
 * ```
 */

export class InputRrule extends ComponentBase {

  /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
  public require = {
    model: "ngModel",

    form: "?^^form",
};

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = Objects.extend(InputBase.crudBindings, {});

  /** Uses the InputRruleController */
  public controller = InputRruleController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/form-controls/InputRrule.html";
}
